import { render, staticRenderFns } from "./PreShippingTab.vue?vue&type=template&id=6329e74e&"
import script from "./PreShippingTab.vue?vue&type=script&lang=js&"
export * from "./PreShippingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports